import React, { useEffect, useState } from "react";
import CommonForm from "../../../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../../../components/formValidate";
import Snackbar from "../../../../../../components/snackbar/snackbar";
import moment from "moment";

// import { user_area_types_list, user_locations_list } from "../../../user.api";

let area_management = [{ id: "1" }, { id: "2" }, { id: "3" }];
export default function AreaDetails(props) {
  const [formData, setFormData] = useState(props.formData);
  const [keyvalue, setKeyvalue] = useState(0);
  const [count, setCount] = useState(1);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  useEffect(() => {
    setFormData(props.formData);
  }, [props.formData]);
  const handleNextSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!emailRegex.test(formData?.email)) {
      setSnackOpen(true);
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
      return;
    }

    props.action(0, formData);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    // if (!flag) {
    //   handleEventList();
    // }
  };
  const handleCourseChange = (e, i) => {
    let data = { ...formData };

    data.course_details[i] = {
      ...data.course_details[i],
      [e.target.name]: e.target.value,
    };

    setFormData(data);
  };

  const addCourse = (i) => {
    let data = { ...formData };

    data.course_details.push({
      course_name: "",
      course_type: "Technical",
    });
    setFormData(data);
    setCount(count + 1);
  };
  const removeCourse = (i) => {
    let data = { ...formData };
    data.course_details.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };

  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = formData;
    data[name] = value;
    setFormData(data);
    setKeyvalue(keyvalue + 1);
  };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };
  const handleDatePickerChange = (e, name) => {
    let date = e.value;

    if (date) {
      setFormData({ ...formData, [name]: date });
      setKeyvalue(keyvalue + 1);
    } else {
      setFormData({ ...formData, [name]: null });

      setKeyvalue(keyvalue + 1);
    }
  };

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let fileKey = e.target.name;
    let fileType = file.name.split(".").pop().toLowerCase();
    const maxFileSizeMB = 1;

    if (fileKey === "brochure") {
      const allowedTypes = ["pdf"];

      if (!allowedTypes.includes(fileType)) {
        setSnackMessage("File should be in .pdf format");
        setIsSnackError(true);
        setSnackOpen(true);
        return;
      }

      let fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB > maxFileSizeMB) {
        setFormData({
          ...formData,
          brochure_name: null,
          [e.target.name]: null,
        });
        setSnackMessage("File size should not exceed 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
        e.target.value = null;

        return;
      }

      setFormData((prevData) => ({
        ...prevData,
        brochure_name: file.name,
        brochure: file,
      }));
    }
    e.target.value = null;
  };

  const handleImgFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "jpg" ||
      type?.toLowerCase() === "jpeg" ||
      type?.toLowerCase() === "png"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setFormData({
          ...formData,
          logo_name: e.target.files[0].name,
          logo: e.target.files[0],
        });
        // if (props.update) {
        //   props.handlefile();
        // }
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData({
          ...formData,
          logo: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
      setFormData({
        ...formData,
        logo: null,
        [e.target.name]: null,
      });
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  //console.log(formData)
  return (
    <div className="expert ">
      <form onSubmit={handleNextSubmit} className="">
        <div>
          <div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="text"
                label="Company Name"
                required
                // multiline
                name="company_name"
                value={formData?.company_name ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="text"
                label="Address"
                required
                // multiline
                name="address"
                value={formData?.address ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="file"
                // required={!formData.logo_name ? true : false}
                name="logo"
                {...props}
                id="logo"
                fileName={formData?.logo_name}
                label="Logo"
                accept=".jpg,.jpeg,.png"
                type="file"
                variant="outlined"
                onChange={handleImgFileChange}
                className={"mb-2"}
              />
            </div>

            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="text"
                label="Area of Operation/Expertise"
                required
                multiline
                name="area_of_operation"
                value={formData?.area_of_operation ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="text"
                label="Brief Company Description"
                required
                multiline
                name="company_description"
                value={formData?.company_description ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="text"
                label="Contact Person Name"
                required
                name="name"
                value={formData?.name ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="number"
                label="Phone Number"
                required
                disabled
                // multiline
                name="phone"
                value={formData?.phone_number ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="email"
                label="Email"
                disabled={props.update}
                value={formData?.email ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                required
                name="email"
                {...props}
              />
            </div>
            <div className="col-xs-12 col-sm-12">
              <label className="control-label mylabel mb-2">
                Alternate Phone Number
              </label>
              <div className="d-flex col-12 align-items-end ">
                <div className="col-1 ">
                  <CommonForm
                    fieldType="text"
                    // required
                    error={error.alt_country_code}
                    name="alt_country_code"
                    maxLength="4"
                    value={formData?.alt_country_code ?? ""}
                    onChange={(e) => {
                      handleNumberChange(e);
                    }}
                    {...props}
                  />
                </div>
                <div className="p-1"></div>
                <div className="col-11 alt-phone-col">
                  <CommonForm
                    // required
                    fieldType="text"
                    error={error.alternate_phone}
                    name="alternate_phone"
                    maxLength="10"
                    value={formData?.alternate_phone ?? ""}
                    onChange={(e) => {
                      handleNumberChange(e);
                    }}
                    {...props}
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12">
              <CommonForm
                fieldType="email"
                label="Alternate Email"
                // disabled={props.update}
                value={formData?.alternate_email ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                // required
                name="alternate_email"
                {...props}
              />
            </div>

            <div>
              <div>
                <div className="section-datas-cont">
                  <div className="col-12">
                    <CommonForm
                      fieldType="file"
                      required={!formData?.brochure_name ? true : false}
                      label="Brochure"
                      name="brochure"
                      {...props}
                      id="brochure"
                      accept=".pdf"
                      type="file"
                      variant="outlined"
                      fileName={formData?.brochure_name}
                      onChange={handleFileChange}
                    />
                    <div className="file-up-helper">
                      *Upload only .pdf format and Size should be less than 1MB
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-buttons ">
          <button type="submit" className="primary-btn ">
            SUBMIT TO PREVIEW
          </button>
        </div>
      </form>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
